import React from 'react';
import { Row, Col } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './ImageDescriptionList.module.less';
import Overlay from '../../../components/Overlay';
import MarkdownText from '../../../components/Text/MarkdownText';
import cx from 'classnames';

const ImageDescriptionList = ({ ecmContent, className = '' }) => {
  const { jsonObject } = ecmContent || {};
  const {
    title,
    text,
    imageUrl,
    descriptionSections,
    downloadName,
    overlayCaption,
    imagePosition,
    imageHeight,
    imageWidthProp
  } = jsonObject || {};

  return (
    <div className={cx([styles.container, { [className]: className }])}>
      {title && <p className={styles.container_title}>{title}</p>}
      {text && <p className={styles.container_text}>{text}</p>}
      <Row className={styles.content_container}>
        {imageUrl && (imagePosition === 'left' || !imagePosition) && (
          <Col
            xs={12}
            xxl={imageWidthProp ? Math.round(imageWidthProp * 12) : 6}
            className={`${styles.image_container}`}
          >
            <Overlay
              src={imageUrl}
              fileName={downloadName}
              caption={overlayCaption}
              imageHeight={imageHeight}
              className={`${styles.overlay}`}
            />
          </Col>
        )}
        {descriptionSections && (
          <Col xs={12} xxl={12 - (imageWidthProp ? Math.round(imageWidthProp * 12) : 6)}>
            {descriptionSections.map((section, index) => (
              <div key={index}>
                {section.description_title && (
                  <div className={`${styles.description_title}`}>
                    <p>{section.description_title}</p>
                  </div>
                )}
                {section.descriptions &&
                  section.descriptions.map((description, index) => (
                    <div key={index} className={`${styles.description_wrapper}`}>
                      <div className={`${styles.custom_badge}`}>
                        <p className={`${styles.custom_badge_text}`}>{index + 1}</p>
                      </div>
                      <p className={`${styles.description_text}`}>
                        <MarkdownText text={description} />
                      </p>
                    </div>
                  ))}
              </div>
            ))}
          </Col>
        )}
        {imageUrl && imagePosition === 'right' && (
          <Col
            xs={12}
            xxl={imageWidthProp ? Math.round(imageWidthProp * 12) : 6}
            className={`${styles.image_container}`}
          >
            <Overlay
              src={imageUrl}
              fileName={downloadName}
              caption={overlayCaption}
              imageHeight={imageHeight}
              className={`${styles.overlay}`}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

ImageDescriptionList.propTypes = {
  ecmContent: PropTypes.object.isRequired
};

export default ImageDescriptionList;
